"use strict";exports.__esModule=true;exports.default=void 0;var safeMax=function safeMax(arr,fn){if(arr===void 0){arr=[]}var len=arr.length,i=-1,val,maxVal;if(typeof fn==="function"){while(++i<len){val=fn(arr[i],i,arr);if(val!=null&&val>=val){maxVal=val;while(++i<len){val=fn(arr[i],i,arr);if(val!=null&&val>maxVal){maxVal=val}}}}}else{while(++i<len){val=arr[i];if(val!=null&&val>=val){maxVal=val;while(++i<len){val=arr[i];if(val!=null&&val>maxVal){maxVal=val}}}}}return maxVal};var _default=safeMax;exports.default=_default;


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/utils/src/array/safe-max.js
// module id = 6VsW
// module chunks = 5